import $ from "jquery";
/* eslint-disable */

let map,
  markersArray = [],
  locationIDs = [],
  marker,
  markers = new Map(),
  iconBase = themeVars["images"],
  defaultLat = -37.8256314,
  defaultLng = 145.0023436,
  icon = { url: iconBase + "pin.svg" },
  iconActive = { url: iconBase + "pin-active.svg" },
  markersRaw = document.querySelectorAll(".marker"),
  styles = [
    { elementType: "geometry", stylers: [{ color: "#f6f6f6" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#C3CCDC" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#C3CCDC" }] },
    {
      featureType: "administrative.locality",
      elementType: "labels.text.fill",
      stylers: [{ color: "#000000" }],
    },
    {
      featureType: "poi",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#f6f6f6" }],
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [{ color: "#cecece" }],
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#f6f6f6" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#cecece" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#cecece" }],
    },
    {
      featureType: "transit.station",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#d4d4d4" }],
    },
    {
      featureType: "water",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
  ];

function initMap($el) {
  // Create gerenic map.
  let mapArgs = {
    center: new google.maps.LatLng(defaultLat, defaultLng),
    zoom: 10,
    disableDefaultUI: true,
    zoomControl: true,
    scrollwheel: false,
    styles: styles,
  };

  map = new google.maps.Map($el[0], mapArgs);
  for (var i = 0; i < markersRaw.length; i++) {
    let lat = parseFloat(markersRaw[i].getAttribute("data-lat"));
    let lng = parseFloat(markersRaw[i].getAttribute("data-lng"));
    let id = markersRaw[i].getAttribute("data-id");

    marker = new google.maps.Marker({
      map: map,
      position: { lat: lat, lng: lng },
      icon: icon,
    });
    google.maps.event.addListener(
      marker,
      "click",
      (function (marker, i) {
        return function () {
          popupRemove(id, markers);
          popupAdd(id, markers);
        };
      })(marker, i)
    );
    locationIDs.push(id);
    markersArray.push(marker);
    for (var i = 0; i < locationIDs.length; i++) {
      markers.set(locationIDs[i], markersArray[i]);
    }
    $(".marker-close").on("click", function () {
      popupRemove(id, markers);
    });
  }

  // Return map instance.
  return map;
}

function popupAdd(id, markers) {
  $(`.marker-${id}`).fadeIn();
  for (var key of markers.keys()) {
    if (key == id) {
      markers.get(key).setIcon(iconActive);
    } else {
      markers.get(key).setIcon(icon);
    }
  }
}

function popupRemove(id, markers) {
  for (var key of markers.keys()) {
    if (key == id) {
      markers.get(key).setIcon(icon);
    }
  }
  $(".marker").fadeOut();
}

$(document).ready(function () {
  $(".map").each(function () {
    let map = initMap($(this));
  });
});

